import type { FC } from 'react';
import { Controller, type Control } from 'react-hook-form';
import Modal from 'react-modal';
import Close from '@mui/icons-material/Close';
import { Box, ClickAwayListener, Fade, IconButton, Popper } from '@mui/material';
import { mask } from 'library/helpers/events/timePicker';
import { useEventEditorTime } from 'library/hooks/events';
import { InputMask, TimePopUp } from './frames';
import * as st from './TimePicker.module.scss';

interface Props {
  control: Control<any>;
  disabled: boolean;
  label: string;
  index: number;
  name: any;
}

const TimePicker: FC<Props> = ({ control, name, disabled, label, index }) => {
  const timeEditor = useEventEditorTime();

  return (
    <>
      <Controller
        control={control}
        name={name}
        render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
          <>
            <InputMask
              value={timeEditor.normalizeTime(value)}
              onChange={onChange}
              onBlur={onBlur}
              mask={mask}
              disabled={disabled}
              handler={timeEditor.handleInputBtnClick}
              label={label}
              name={name}
              error={error?.message ?? ''}
              matches={timeEditor.matches}
              index={index}
              getDate={timeEditor.getDate}
            />

            {timeEditor.visible &&
              (timeEditor.matches ? (
                <Popper
                  id={timeEditor.idAnchor}
                  open={timeEditor.visible}
                  anchorEl={timeEditor.anchorEl}
                  transition
                  style={{ zIndex: 20 }}
                >
                  {({ TransitionProps }) => (
                    <Fade {...TransitionProps} timeout={350}>
                      <Box>
                        <ClickAwayListener onClickAway={timeEditor.handlePopUpClose}>
                          <Box>
                            <TimePopUp
                              getDate={timeEditor.getDate}
                              index={index}
                              setChecked={timeEditor.setChecked}
                              value={timeEditor.normalizeValue(value)}
                              onChange={onChange}
                              handler={timeEditor.handlePopUpClose}
                              checked={timeEditor.checked}
                            />
                          </Box>
                        </ClickAwayListener>
                      </Box>
                    </Fade>
                  )}
                </Popper>
              ) : (
                <Modal
                  isOpen={timeEditor.visible}
                  ariaHideApp={false}
                  className={st.modal}
                  overlayClassName={st.overlay}
                  onRequestClose={timeEditor.handlePopUpClose}
                  shouldCloseOnOverlayClick={true}
                >
                  <TimePopUp
                    getDate={timeEditor.getDate}
                    index={index}
                    setChecked={timeEditor.setChecked}
                    value={timeEditor.normalizeValue(value)}
                    onChange={onChange}
                    handler={timeEditor.handlePopUpClose}
                    checked={timeEditor.checked}
                  />
                  <IconButton
                    onClick={timeEditor.handlePopUpClose}
                    sx={{ position: 'absolute', zIndex: '100002', top: '2px', right: '0' }}
                  >
                    <Close />
                  </IconButton>
                </Modal>
              ))}
          </>
        )}
      />
    </>
  );
};

export default TimePicker;
